module.exports = __webpack_public_path__ + "static/media/icon-scheduling-calendar.4eed8905.svg";